<template>
  <family-page-wrapper class="family-membership-plan">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">
          Membership Plans
        </h3>
      </div>

      <hr class="card-title-line">

      <div class="card-content">
        <price-planning
          :is-current-plan-btn-disable="true"
          @choose-membership="chooseMembership"
        />
      </div>
    </div>
  </family-page-wrapper>
</template>

<script lang="ts">
import { ElLoading } from 'element-plus';

import util from '@/Utils/util';
import { useCustomer } from '@/use/customer';
import { useSwalDialog } from '@/use/swalDialog';
import { callerPlanService } from '@/services/callerPlan';

import PricePlanning from '@/components/UIComponents/PricePlanning.vue';

export default {
  name: 'FamilyMembershipPlan',

  components: {
    PricePlanning,
  },

  setup: () => {
    const { customerInfo, setCustomerActivePlan } = useCustomer();

    const { showSuccessPopupDialog, showErrorPopupDialog } = useSwalDialog();

    const chooseMembership = async (planName: string) => {
      const loading = ElLoading.service({
        lock: true,
        text: 'Updating membership plan...',
        background: 'rgba(0, 0, 0, 0.7)',
        customClass: 'custom-full-spinner-class',
      });

      try {
        const planInfo = await callerPlanService.updateCallerSubscription({
          planName,
          callerId: customerInfo.value.id,
        });

        if (!planInfo) {
          return;
        }

        setCustomerActivePlan(planInfo);

        showSuccessPopupDialog({
          text: 'The membership has been updated successfully.',
        });
      } catch (error) {
        const errorText = util.getGraphqlError(error, false);
        showErrorPopupDialog({
          text: errorText,
        });
      } finally {
        loading.close();
      }
    };

    return {
      customerInfo,
      chooseMembership,
    };
  },
};
</script>

<style lang="scss">
.family-membership-plan.page-content {
  .card {
    max-width: unset !important;
  }
}
</style>
